export default "__VITE_ASSET__c0163a38__"